import { useNavigate } from 'react-router-dom'
import { getMultiMarketPath } from '../../controls/ProjectListItem/ProjectListItem.utils'
import { ProjectType } from '../../data/gql-gen/dashboard/graphql'

interface ProjectNavigationTarget {
  projectType: ProjectType
  projectId: string
  surveys: ReadonlyArray<{ surveyId: string }>
}

export const useNavigateToInitialProjectPage = () => {
  const navigate = useNavigate()
  return ({ projectType, projectId, surveys }: ProjectNavigationTarget) => {
    const surveyId = surveys[0].surveyId
    switch (projectType) {
      case ProjectType.MultiMarketV2:
      // A tracker opens on its project page, where waves are added.
      case ProjectType.Tracker:
        navigate(getMultiMarketPath(projectId))
        break
      case ProjectType.FdChat:
        navigate(`/fdchat/${surveyId}`)
        break
      default:
        navigate(`/survey/${surveyId}/audience`)
        break
    }
  }
}
